if (!customElements.get('thankyou-modal')) {
    console.log("Hello");
  customElements.define(
    'thankyou-modal',
    class ThankYouModel extends ModalElement {
      constructor() {
        super();
      }

      get shouldLock() {
        return true;
      }
    }
  );
}